import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AnimatedValue from "../../components/AnimatedNumber";
import { useWidgetInfo } from "../../utils/useWidgetInfo";
import WidgetInfo from "../../components/WidgetInfo";
import { ArrowDown, ArrowUp } from "lucide-react";
import clsx from "clsx";
import { IconQuestion } from "../../assets/icons";

export const EstimatedHomeEquity = ({ className }) => {
  const { t } = useTranslation();
  const { currentMortgage, previousMortgage } = useSelector(
    (store) => store.valuationsDetails
  );

  const currentEquity = useMemo(
    () =>
      currentMortgage?.latestEstimatedOfferPrice -
      currentMortgage?.currentValue,
    [currentMortgage]
  );
  const previousEquity = useMemo(
    () =>
      previousMortgage?.latestEstimatedOfferPrice -
      previousMortgage?.currentValue,
    [previousMortgage]
  );

  const widgetInfoState = useWidgetInfo();

  return (
    <>
      <div
        className={clsx(
          "rounded-lg bg-accumin-neutral-100 p-4 h-[106px] flex flex-col justify-center",
          className
        )}
      >
        <div className="flex justify-between">
          <div className="mb-4 ">
            {t(`finances.total-estimated-home-equity`)}
          </div>
          <div className="pl-4 pb-2 cursor-pointer">
            <IconQuestion
              className="fill-accumin-primary-electric-blue h-6 w-6 p-1 bg-accumin-secondary-sky-blue rounded-full"
              onClick={() =>
                widgetInfoState.handleOpen("labels.value-terminology", "", [
                  {
                    title: "finances.total-estimated-home-equity",
                    key: "equity.total-estimated-home-equity"
                  }
                ])
              }
            />
          </div>
        </div>
        <div className="w-full">
          <div className="flex justify-between items-center mb-1 w-full">
            <div className="flex gap-2 items-center">
              <div className="text-xl font-semibold text-accumin-primary-purple">
                &#36;
              </div>
              <AnimatedValue
                value={currentEquity}
                withDecimals={true}
                className="text-xl font-semibold text-accumin-primary-purple"
              />
            </div>
            <div className="flex gap-2 items-center h-6">
              {!Number.isNaN(previousEquity) &&
                currentEquity > previousEquity && (
                  <div className="rounded-lg p-2 flex gap-1 items-center w-8 h-8 bg-success-100 justify-center">
                    <ArrowUp className="text-white bg-green-400 rounded-xl p-[2px] border-0 w-4 h-4" />
                  </div>
                )}
              {!Number.isNaN(previousEquity) &&
                currentEquity < previousEquity && (
                  <div className="rounded-lg p-2 flex gap-1 items-center w-8 h-8 bg-accumin-functional-pastel-magenta justify-center">
                    <ArrowDown className="text-white bg-accumin-secondary-magenta rounded-xl p-[2px] border-0 w-4 h-4" />
                  </div>
                )}

              <div className="text-xs">
                {currentMortgage?.createdAt
                  ? new Date(currentMortgage.createdAt)
                      .toLocaleDateString("es-MX")
                      .replaceAll("/", ".")
                  : "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <WidgetInfo state={widgetInfoState} />
    </>
  );
};

export default EstimatedHomeEquity;
